import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';

@Injectable({
  providedIn: 'root',
})
export class SESService {
  constructor(private fbs: FirebaseService) {}

  async getAllEmailTemplates(): Promise<any[]> {
    try {
      const result: any = await this.fbs.callableFunction(
        'getAllSESTemplates',
        {}
      );
      if (result.success) {
        console.log('All SES Templates:', result.data);
        return result.data;
      } else {
        console.error('Error fetching SES templates:', result.message);
        return [];
      }
    } catch (error) {
      console.error('Error fetching SES templates:', error);
      return [];
    }
  }

  /** @deprecated Use email-editor's templateHandler() instead. This method only creates English-only templates. */
  async createSESTemplate(template: any) {
    try {
      const result: any = await this.fbs.callableFunction('createTemplates', {
        templateName: template.TemplateName,
        subjectPart: { en: template.SubjectPart },
        htmlPart: { en: template.HtmlPart },
        languageCodes: ['en'],
      });
      if (result.success) {
        console.log('Template Created Successfully', result.data);
      } else {
        console.error('Error creating template:', result.message);
      }
    } catch (error) {
      console.error('Error creating template:', error);
    }
  }

  /** @deprecated Use email-editor's templateHandler() instead. This method only creates English-only templates. */
  async updateSESTemplate(template: any) {
    try {
      const result: any = await this.fbs.callableFunction('updateTemplates', {
        templateName: template.TemplateName,
        subjectPart: { en: template.SubjectPart },
        htmlPart: { en: template.HtmlPart },
        languageCodes: ['en'],
      });
      if (result.success) {
        console.log('Template Updated Successfully', result.data);
      } else {
        console.error('Error updating template:', result.message);
      }
    } catch (error) {
      console.error('Error updating template:', error);
    }
  }

  async deleteSESTemplate(templateName: string) {
    try {
      const result: any = await this.fbs.callableFunction('deleteTemplate', {
        templateName,
      });
      if (result.success) {
        console.log(
          `Template "${templateName}" deleted successfully`,
          result.data
        );
      } else {
        console.error(
          `Error deleting template "${templateName}":`,
          result.message
        );
      }
    } catch (error) {
      console.error(`Error deleting template "${templateName}":`, error);
    }
  }

  async getTemplateContent(templateName: string) {
    try {
      const result: any = await this.fbs.callableFunction('getTemplateByName', {
        templateName,
      });
      if (result.success && result.data) {
        console.log('Template Content:', result.data.Template);
        return result.data.Template;
      } else {
        console.error(
          `Error fetching template content for ${templateName}:`,
          result.message
        );
        return null;
      }
    } catch (error) {
      console.error(
        `Error fetching template content for ${templateName}:`,
        error
      );
      return null;
    }
  }
}
